import * as types from '../actionsTypes/anagraficheActionType';
import new_axios_instance from '../../axios_instance';
import {notifsActions, loadingOverlayActions} from "../index";
import {createMessageRequestException} from "../../fanctionUtility";
import {ENUM_RUOLI} from "../../costanti";

export const inserisciModifcaAnagrafica = (param, typeRole) => async dispatch => {
    let url;
    switch (typeRole) {
        case ENUM_RUOLI.ADMIN : {
            url = '/v1/utenteanagrafica/inserisci/ruolo';
            break;
        }
        case ENUM_RUOLI.ENTE : {
            url = '/v1/utenteanagrafica/inserisci/ruoloEnte';
            break;
        }
        case ENUM_RUOLI.UTR : {
            url = '/v1/utenteanagrafica/inserisci/ruoloUTR';
            break;
        }
        case ENUM_RUOLI.RDA: {
            url = '/v1/utenteanagrafica/inserisci/ruoloRDA';
            break;
        }
        default:
            break;
    }

    if (url != null && url !== '') {
        // dispatch(initAnagraficaRuoli());
        dispatch(loadingOverlayActions.showLoadingOverlay());

        await new_axios_instance.post(url, param)
            .then(_ => {
                dispatch(inserisciModifcaAnagraficaSuccess(typeRole.toUpperCase()));
                dispatch(loadingOverlayActions.hideLoadingOverlay());
                dispatch(notifsActions.notifSuccess(`Operazione eseguita con successo. Utente censito come ${typeRole.toUpperCase()}`));
            }).catch(error => {
                const message = createMessageRequestException(error);

                dispatch(inserisciModifcaAnagraficaFail(message, typeRole.toUpperCase()));
                dispatch(notifsActions.notifError(`${typeRole.toUpperCase()}: ${message}`));
                dispatch(loadingOverlayActions.hideLoadingOverlay());

            });
    } else {
        dispatch(notifsActions.notifError('Errore nella selezione dei ruoli'));
    }

};

export const inserisciModifcaAnagraficaSuccess = (role) => {
    return {
        type: types.INSERISCI_MODIFICA_ANAGRAFICA_SUCCESS,
        role
    }
};

export const inserisciModifcaAnagraficaFail = (error, role) => {
    return {
        type: types.INSERISCI_MODIFICA_ANAGRAFICA_FAIL,
        error,
        role
    }
};

export const initAnagraficaRuoli = () => {
    return {
        type: types.INIT_ANAGRAFICA_RUOLI
    }
};
